import { createComponent, createElement, computed } from "@vue/composition-api";
import { ResourceIdentifier } from "@megarax/client/src/resources/Resource";
import { getResourceModulePath } from "@/apps/getPath";

interface Props {
  resource: ResourceIdentifier;
  itemId: number | string;
}

export default createComponent<Props>({
  name: "ResourceItemHyperlink",
  props: {
    resource: { required: true },
    itemId: { required: true },
  },
  setup(props, ctx) {
    const path = computed(() =>
      getResourceModulePath(props.resource, props.itemId),
    );

    return () =>
      createElement(
        path.value ? "router-link" : "span",
        {
          props: {
            to: path.value,
          },
        },
        ctx.slots.default(),
      );
  },
});
